export default function requestPilets() {
  return Promise.resolve([]);
}
